import React from 'react';
import Box from '../box';
import { useStyleConfig, vui } from '../core';
import Link from '../link';
import T from '../t';
import { cs } from '../utils';
import { useFooterContext } from './context';
import FooterColumn from './footerColumn';
import FooterHeading from './footerHeading';
export const defaultLinkedInUrl = 'https://www.linkedin.com/showcase/veracity-data-platform';
/** Section includes a heading and a set of links. */
export const FooterTrademark = vui((props, ref) => {
    const { className, linkedIn, ...rest } = props;
    const styles = useStyleConfig('Footer', useFooterContext());
    return (React.createElement(Box, { className: cs('vui-footerTrademark', className), ref: ref, w: "100%", wrap: true, ...styles.trademark, ...rest },
        React.createElement(FooterColumn, { centerV: true, flex: { xs: '0 0 100%', md: '0 0 25%' } },
            React.createElement(Link, { fontWeight: "demi", href: linkedIn ?? defaultLinkedInUrl, iconLeft: React.createElement(Link.Icon, { mr: 1, name: "cubCircleLinkedIn", radius: "50%", size: "sm" }), isExternal: true, ...styles.link },
                React.createElement(FooterHeading, { mb: 0, text: "Follow us" }))),
        React.createElement(FooterColumn, { centerV: true, flex: { xs: '0 0 100%', md: '0 0 75%' } },
            React.createElement(T, { size: "xs" },
                React.createElement(T, { size: "xs", weight: "demi" }, "Veracity by DNV"),
                ", DNV AS, NO-1322 H\u00F8vik, Norway"))));
});
export default FooterTrademark;
